module.exports = __webpack_public_path__ + "img/checkbox-unchecked.4618a03c.svg";